module.exports = __webpack_public_path__ + "themify.9c8e96ecc7fa01e6ebcd.svg";


//////////////////
// WEBPACK FOOTER
// /builds/faixa-azul/faixa-azul-fad-web/node_modules/cd-themify-icons/fonts/themify.svg
// module id = ../../../../cd-themify-icons/fonts/themify.svg
// module chunks = styles